import { createValidator, ErrorObject, required } from 'util/validation'

import { validatorConsultaSeguimentoOutro } from '../../utils-consultaSeguimento'
import { isStatusValid } from '../../validator-consultaSeguimento'
import { ConsultaSeguimentoPergunta17Model } from './model-consultaSeguimentoPergunta17'
import { hasPergunta17TentaFazerQueOlheAnySim } from './utils-consultaSeguimentoPergunta17'

export const validatorConsultaSeguimentoPergunta17 = createValidator<ConsultaSeguimentoPergunta17Model>(
  {
    resultado: required,
    status: isStatusValid,
    PERGUNTA_17_HEADER: required,
    OUTRO: validatorConsultaSeguimentoOutro,
  },
  (values: ConsultaSeguimentoPergunta17Model, errors: ErrorObject<ConsultaSeguimentoPergunta17Model>) => {
    if (!hasPergunta17TentaFazerQueOlheAnySim(values)) {
      errors.PERGUNTA_17_TENTA_FAZER_QUE_OLHE = createValidator<
        ConsultaSeguimentoPergunta17Model['PERGUNTA_17_TENTA_FAZER_QUE_OLHE']
      >({
        CONTINUA_OLHANDO: required,
        EMITE_SOM_OU_BARULHO: required,
        FALA: required,
        OLHA_PARA: required,
      })(values?.PERGUNTA_17_TENTA_FAZER_QUE_OLHE)
    }
    return errors
  }
)
